import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Stack, IconButton, Typography, Button } from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

import { Disclaimer } from '../../../components/Disclaimer';
import TypographyLink from '../../../components/TypographyLink';
import { DEFAULT_PARKING_FILTERS_FORM_VALUES, ParkingFiltersForm } from './parking-filters-form';
import { useForm } from 'react-hook-form';
import { navigate } from 'gatsby';
import { ParkingFilters, parkingFiltersSchema } from '../../../domain/parking';
import { storeParkingFiltersInLocalStorage } from '../utils';
import { yupResolver } from '@hookform/resolvers/yup';

export default function HomeParkingReservation({ onBackClick = () => { } }) {
  const { t } = useTranslation();
  const form = useForm({ 
    defaultValues: DEFAULT_PARKING_FILTERS_FORM_VALUES,
    resolver: yupResolver(parkingFiltersSchema),
  });

  const submitParkingForm = (values: ParkingFilters) => {
    storeParkingFiltersInLocalStorage(values);

    navigate('/checkout/parking');
  };

  return (
    <Stack gap={3}>
      <Stack direction="row" alignItems="center" gap={1}>
        <IconButton onClick={onBackClick}>
          <KeyboardBackspaceIcon sx={{ color: 'rgba(239, 96, 163, 1)' }} />
        </IconButton>
        <Typography variant="h5" component="h2" color="primary" fontWeight={700}>
          {t('parking_service.name')}
        </Typography>
      </Stack>
      <Typography variant="body2">{t('parking_service.ample_parking_options_valet_self_service')}</Typography>

      <ParkingFiltersForm formManager={form} />

      <Stack alignItems="flex-end">
        <Button
          disabled={!form.formState.isValid}
          sx={{ width: 200 }}
          size="large"
          variant="contained"
          onClick={form.handleSubmit(submitParkingForm)}
        >
          {t('add_to_shopping_cart')}
        </Button>
      </Stack>

      <Disclaimer variant="important">
        <Disclaimer.Content>
          {t('parking_service.park_in_reserved_lot_free_cancel_24hrs_before')}
          <br />
          <br />
          <TypographyLink href="/parking" bold underline={false}>
            {t('read_our_terms_and_conditions')}
          </TypographyLink>
        </Disclaimer.Content>
      </Disclaimer>
    </Stack>
  );
}
